import { createRouter, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
// import HistroyRaceDashboardView from '../views/HistroyRaceDashboardView.vue'
// import SelectRaceView  from '../views/SelectRaceView.vue'
// import AdminLoginView from '@/views/AdminLoginView.vue'
// import AdminMain from '@/views/AdminMain.vue'
// import ChatF1CommonChat from '@/views/ChatF1CommonChat.vue'
// import F12026 from '@/views/F12026.vue'
// import F12026Fullscreen from '@/views/F12026Fullscreen.vue'



const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      // route level code-splitting
      // this generates a separate chunk (HomeView.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/HomeView.vue')
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue')
    },
    {
      path: '/histroyRaceDashboard',
      name: 'histroyRaceDashboard',
      // route level code-splitting
      // this generates a separate chunk (HistroyRaceDashboardView.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/HistroyRaceDashboardView.vue')
    },
    {
      path: '/selectRace',
      name: 'selectRace',
      // route level code-splitting
      // this generates a separate chunk (SelectRaceView.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/SelectRaceView.vue')
    },
    {
      path: '/admin/login',
      name: 'adminLogin',
      // route level code-splitting
      // this generates a separate chunk (AdminLoginView.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/AdminLoginView.vue')
    },
    {
      path: '/admin/main',
      name: 'adminMain',
      // route level code-splitting
      // this generates a separate chunk (AdminMain.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/AdminMain.vue')
    },
    {
      path: '/chatf1',
      name: 'chatf1',
      // route level code-splitting
      // this generates a separate chunk (ChatF1CommonChat.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/ChatF1CommonChat.vue')
    },
    {
      path:'/f12026',
      name: 'f12026',
      // route level code-splitting
      // this generates a separate chunk (F12026.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/F12026.vue')
    },
    {
      path:'/f12026Fullscreen',
      name: 'f12026Fullscreen',
      // route level code-splitting
      // this generates a separate chunk (F12026Fullscreen.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/F12026Fullscreen.vue')
    },
    {
      path: '/driver-live-data',
      name: 'driverLiveData',
      // route level code-splitting
      // this generates a separate chunk (DriverLiveDataView.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/DriverLiveDataView.vue')
    }
  ]
})

export default router
